import { getReportLinkPermissionName } from "./get-report-link-permission-name.js";
import { isReportLinkActive } from "./is-report-link-active.js";

/**
 * Verifica se o usuário pode ver o report-link na sidebar / viewer.
 * Regra estrita: exige papel correspondente e islist === true.
 * @param {Object} reportLink
 * @param {Object[]} userRoles - roles do usuário (permissionsContext / user_token)
 * @returns {boolean}
 */
export function canUserViewReportLink(reportLink, userRoles) {
  if (!isReportLinkActive(reportLink)) {
    return false;
  }

  const permissionName = getReportLinkPermissionName(reportLink);

  if (!permissionName) {
    return false;
  }

  const normalizedPermissionName = String(permissionName).trim().toLowerCase();
  const roles = Array.isArray(userRoles) ? userRoles : [];
  const role = roles.find(
    (item) =>
      String(item?.name ?? "")
        .trim()
        .toLowerCase() === normalizedPermissionName,
  );

  return role?.islist === true || role?.isList === true;
}
